import Cookies from 'js-cookie';
import { MODEL_CATEGORY_ACTION_TYPES } from '../constants/index';
import {
    MODELCATEGORY_MANAGEMENT,
    UPDATE_MODELCATEGORY,
    CREATE_MODELCATEGORY
} from '../constants/logs';
import { apiAction, logEntry } from '../utils/index';

const envName = process.env.REACT_APP_ENV_NAME_SHORT;

// ModelCategory Management
export const setModelCategoryErrorThunk = err => dispatch => {

    let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
    messageCode = messageCode && messageCode.replace('[400]=>', '');
    dispatch(setModelCategoryError(messageCode, true));
    setTimeout(() => {
        //Hide the banner
        dispatch(setModelCategoryError(messageCode, false));
    }, 2500);
};

export const setModelCategoryError = (messageCode, status) => {
    return {
        type: MODEL_CATEGORY_ACTION_TYPES.MODELCATEGORY_ERROR,
        payload: {
            data: {
                isOpSuccessful: false,
                showBanner: status,
                isLoading: false,
                displayMessageCode: messageCode || ''
            }
        }
    };
};
export const getModelCategoriesThunk = (offset, limit, filter, widgetCode, organisationId) => dispatch => {

    dispatch(getModelCategory(offset, limit, filter, widgetCode, organisationId));
};

export const setModelCategoryLoadingStatus = isLoading => ({
    type: MODEL_CATEGORY_ACTION_TYPES.MODELCATEGORY_IS_LOADING,
    payload: { isLoading }
});

export const getModelCategory = (offset, limit, filter, widgetCode, organisationId) =>
    apiAction({
        url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}/management/modelcategory`,
        data: {
            Offset: offset,
            Limit: limit,
            Filter: filter,
            OwnerId: organisationId ? organisationId : undefined
        },
        method: 'GET',
        onLoad: status => setModelCategoryLoadingStatus(status),
        onSuccess: retData => setAllModelCategoryListThunk(retData),
        onFailure: err => setModelCategoryErrorThunk(err),
        accessToken: Cookies.get(`access-${envName}`),
        widgetcode: widgetCode
    });

export const setAllModelCategoryListThunk = retData => dispatch => {
    let messageCode = retData && retData.message;
    let modelcategories = (retData && retData.modelCategories) || [];
    dispatch(setAllModelCategoryList(messageCode, modelcategories));
};

export const setAllModelCategoryList = (messageCode, modelCategories) => ({
    type: MODEL_CATEGORY_ACTION_TYPES.GET_ALL_MODELCATEGORY_DETAILS,
    payload: {
        data: {
            modelCategories,
            filteredResults: modelCategories,
            isLoading: false,
            displayMessageCode: messageCode,
            showBanner: false,
            isOpSuccessful: false
        }
    }
});

export const setModelCategoryCurrentPage = currentPage => ({
    type: MODEL_CATEGORY_ACTION_TYPES.SET_MODELCATEGORY_CURRENT_PAGE,
    payload: { currentPage }
});

export const setModelCategoryPageFilter = filter => ({
    type: MODEL_CATEGORY_ACTION_TYPES.SET_MODELCATEGORY_PAGE_FILTER,
    payload: { filter }
});

export const postModelCategoryThunk = (modelCategory, widgetCode) => dispatch => {
    let url = '/management/modelcategory/save';
    let actionName = modelCategory.ModelCategoryId === 0 ? CREATE_MODELCATEGORY : UPDATE_MODELCATEGORY;
    let log = logEntry(MODELCATEGORY_MANAGEMENT, actionName, modelCategory);
    dispatch(saveModelCategory(modelCategory, url, log, widgetCode));
};

export const saveModelCategory = (modelCategory, url, log, widgetCode) =>
    apiAction({
        url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}${url}`,
        method: 'POST',
        widgetcode: widgetCode,
        onLoad: status => setModelCategoryLoadingStatus(status),
        onSuccess: message => setModelCategoryStatusThunk(message),
        onFailure: err => setModelCategoryErrorThunk(err),
        accessToken: Cookies.get(`access-${envName}`),
        data: {
            ModelCategory: modelCategory,
            log
        }
    });

export const setModelCategoryStatusThunk = message => dispatch => {
    dispatch(setModelCategoryStatus(message, true));
    setTimeout(() => {
        //Hide the banner
        dispatch(setModelCategoryStatus('', false));
    }, 2500);
};

export const setModelCategoryStatus = (messageCode, status) => ({
    type: MODEL_CATEGORY_ACTION_TYPES.UPDATE_MODELCATEGORY_USER_SAVE_STATUS,
    payload: {
        data: {
            isOpSuccessful: true,
            showBanner: status,
            isLoading: false,
            displayMessageCode: messageCode || ''
        }
    }
});

export const describeModelCategoryThunk = (modelCategoryId, organisationId, widgetCode) => dispatch => {
    dispatch(describeModelCategory(modelCategoryId, organisationId, widgetCode));
};

export const describeModelCategory = (modelCategoryId, organisationId, widgetCode) =>
    apiAction({
        url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}/management/modelcategory`,
        data: {
            ModelCategoryId: modelCategoryId || undefined,
            OwnerId: organisationId ? organisationId : undefined
        },
        method: 'GET',
        onLoad: status => setModelCategoryLoadingStatus(status),
        onSuccess: retData => setDescribeModelCategoryThunk(retData),
        onFailure: err => setModelCategoryErrorThunk(err),
        accessToken: Cookies.get(`access-${envName}`),
        widgetcode: widgetCode
    });

export const setDescribeModelCategoryThunk = retData => dispatch => {
    dispatch(setDescribeModelCategory(retData));
};

export const setDescribeModelCategory = ({ catData }) => ({
    type: MODEL_CATEGORY_ACTION_TYPES.SET_MODELCATEGORY_DETAILS,
    payload: catData
});

export const setModelCategoryChangeThunk = retData => dispatch => {
    dispatch(setModelCategoryChange(retData));
};

export const setModelCategoryChange = retData => ({
    type: MODEL_CATEGORY_ACTION_TYPES.SET_MODELCATEGORY_CHANGE,
    payload: retData
});

export const setFilteredModelCategoryDataThunk = retData => dispatch => {
    dispatch(setFilteredModelCategoryData(retData));
};

export const setFilteredModelCategoryData = retData => ({
    type: MODEL_CATEGORY_ACTION_TYPES.SET_MODELCATEGORY_FILTERED_RESULTS,
    payload: retData
});

export const modelCategoryCleanUpThunk = modelCategory => dispatch => {
    dispatch(modelCategoryCleanUp(modelCategory));
};

export const modelCategoryCleanUp = modelCategory => ({
    type: MODEL_CATEGORY_ACTION_TYPES.MODELCATEGORY_CLEANUP,
    payload: {
        data: modelCategory
    }
});